// Light/dark/system theme switching.
//
// The initial application happens in an inline script in the layout head, so
// there's no flash on load. This file only handles changes made after load.
//
// Two attributes on <html>:
//   data-theme      — the resolved value ('light' | 'dark'), what the CSS matches
//   data-theme-pref — the user's actual choice, which may be 'system'
const STORAGE_KEY = 'theme'
const DARK_QUERY = '(prefers-color-scheme: dark)'

function resolve(pref) {
  if (pref === 'system') {
    return window.matchMedia(DARK_QUERY).matches ? 'dark' : 'light'
  }
  return pref
}

function apply(pref) {
  const html = document.documentElement
  html.setAttribute('data-theme', resolve(pref))
  html.setAttribute('data-theme-pref', pref)
}

export function currentPreference() {
  return document.documentElement.getAttribute('data-theme-pref') || 'system'
}

export function isDark() {
  return document.documentElement.getAttribute('data-theme') === 'dark'
}

export function setTheme(pref) {
  apply(pref)

  try {
    window.localStorage.setItem(STORAGE_KEY, pref)
  } catch (e) {
    // Safari private browsing throws on setItem; the attribute is already set,
    // so the theme still applies for this page view.
  }

  // Persist server-side so it follows signed-in users across devices. The CSRF
  // header comes from the $.ajaxSetup in application.js.
  if (document.documentElement.dataset.signedIn === 'true') {
    $.ajax({ url: '/theme', method: 'PATCH', data: { theme: pref } })
  }

  markActive()
}

// Font Awesome 4 class per preference, for the header dropdown's toggle icon.
const PREF_ICONS = {
  light: 'fa-sun-o',
  dark: 'fa-moon-o',
  system: 'fa-adjust'
}

// Reflect the current choice on any control that offers it: mark the active
// option, and point the header dropdown's icon at the current preference the way
// getbootstrap.com does.
function markActive() {
  const pref = currentPreference()

  document.querySelectorAll('[data-theme-set]').forEach((el) => {
    el.classList.toggle('active', el.getAttribute('data-theme-set') === pref)
  })

  document.querySelectorAll('[data-theme-icon]').forEach((icon) => {
    Object.values(PREF_ICONS).forEach((cls) => icon.classList.remove(cls))
    icon.classList.add(PREF_ICONS[pref] || PREF_ICONS.system)
  })
}

// Follow the OS live, but only while the user has actually chosen 'system'.
window.matchMedia(DARK_QUERY).addEventListener('change', () => {
  if (currentPreference() === 'system') apply('system')
})

// Delegated so it works for controls inside React components and modals too.
document.addEventListener('click', (event) => {
  const control = event.target.closest('[data-theme-set]')
  if (!control) return

  event.preventDefault()
  setTheme(control.getAttribute('data-theme-set'))
})

document.addEventListener('DOMContentLoaded', markActive)
